
/**
* NOTE: This Json type is patched by scripts/patch-json-type.mjs after every
* `yarn db:gen-types`. Supabase generates a self-referential Json type whose deep
* recursion makes camelcase-keys' type inference blow the TS instantiation depth
* limit (TS2589). The non-recursive form below avoids that; call sites narrow
* JSON columns (e.g. metric config/value) to their concrete shapes anyway.
*/
export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: unknown }
  | unknown[]

export type Database = {
  
  "auth": {
          Tables: {
            "audit_log_entries": {
                  Row: {
                    "created_at": string | null,"id": string,"instance_id": string | null,"ip_address": string,"payload": Json | null
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string | null,"id": string,"instance_id"?: string | null,"ip_address"?: string,"payload"?: Json | null
                  }
                  Update: {
                    "created_at"?: string | null,"id"?: string,"instance_id"?: string | null,"ip_address"?: string,"payload"?: Json | null
                  }
                  Relationships: [
                    
                  ]
                },"custom_oauth_providers": {
                  Row: {
                    "acceptable_client_ids": (string)[],"attribute_mapping": NonNullable<Json>,"authorization_params": NonNullable<Json>,"authorization_url": string | null,"cached_discovery": Json | null,"client_id": string,"client_secret": string,"created_at": string,"discovery_cached_at": string | null,"discovery_url": string | null,"email_optional": boolean,"enabled": boolean,"id": string,"identifier": string,"issuer": string | null,"jwks_uri": string | null,"name": string,"pkce_enabled": boolean,"provider_type": string,"scopes": (string)[],"skip_nonce_check": boolean,"token_url": string | null,"updated_at": string,"userinfo_url": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "acceptable_client_ids"?: (string)[],"attribute_mapping"?: NonNullable<Json>,"authorization_params"?: NonNullable<Json>,"authorization_url"?: string | null,"cached_discovery"?: Json | null,"client_id": string,"client_secret": string,"created_at"?: string,"discovery_cached_at"?: string | null,"discovery_url"?: string | null,"email_optional"?: boolean,"enabled"?: boolean,"id"?: string,"identifier": string,"issuer"?: string | null,"jwks_uri"?: string | null,"name": string,"pkce_enabled"?: boolean,"provider_type": string,"scopes"?: (string)[],"skip_nonce_check"?: boolean,"token_url"?: string | null,"updated_at"?: string,"userinfo_url"?: string | null
                  }
                  Update: {
                    "acceptable_client_ids"?: (string)[],"attribute_mapping"?: NonNullable<Json>,"authorization_params"?: NonNullable<Json>,"authorization_url"?: string | null,"cached_discovery"?: Json | null,"client_id"?: string,"client_secret"?: string,"created_at"?: string,"discovery_cached_at"?: string | null,"discovery_url"?: string | null,"email_optional"?: boolean,"enabled"?: boolean,"id"?: string,"identifier"?: string,"issuer"?: string | null,"jwks_uri"?: string | null,"name"?: string,"pkce_enabled"?: boolean,"provider_type"?: string,"scopes"?: (string)[],"skip_nonce_check"?: boolean,"token_url"?: string | null,"updated_at"?: string,"userinfo_url"?: string | null
                  }
                  Relationships: [
                    
                  ]
                },"flow_state": {
                  Row: {
                    "auth_code": string | null,"auth_code_issued_at": string | null,"authentication_method": string,"code_challenge": string | null,"code_challenge_method": Database["auth"]['Enums']["code_challenge_method"] | null,"created_at": string | null,"email_optional": boolean,"id": string,"invite_token": string | null,"linking_target_id": string | null,"oauth_client_state_id": string | null,"provider_access_token": string | null,"provider_refresh_token": string | null,"provider_type": string,"referrer": string | null,"updated_at": string | null,"user_id": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "auth_code"?: string | null,"auth_code_issued_at"?: string | null,"authentication_method": string,"code_challenge"?: string | null,"code_challenge_method"?: Database["auth"]['Enums']["code_challenge_method"] | null,"created_at"?: string | null,"email_optional"?: boolean,"id": string,"invite_token"?: string | null,"linking_target_id"?: string | null,"oauth_client_state_id"?: string | null,"provider_access_token"?: string | null,"provider_refresh_token"?: string | null,"provider_type": string,"referrer"?: string | null,"updated_at"?: string | null,"user_id"?: string | null
                  }
                  Update: {
                    "auth_code"?: string | null,"auth_code_issued_at"?: string | null,"authentication_method"?: string,"code_challenge"?: string | null,"code_challenge_method"?: Database["auth"]['Enums']["code_challenge_method"] | null,"created_at"?: string | null,"email_optional"?: boolean,"id"?: string,"invite_token"?: string | null,"linking_target_id"?: string | null,"oauth_client_state_id"?: string | null,"provider_access_token"?: string | null,"provider_refresh_token"?: string | null,"provider_type"?: string,"referrer"?: string | null,"updated_at"?: string | null,"user_id"?: string | null
                  }
                  Relationships: [
                    
                  ]
                },"identities": {
                  Row: {
                    "created_at": string | null,"email": string | null,"id": string,"identity_data": NonNullable<Json>,"last_sign_in_at": string | null,"provider": string,"provider_id": string,"updated_at": string | null,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string | null,"email"?: never,"id"?: string,"identity_data": NonNullable<Json>,"last_sign_in_at"?: string | null,"provider": string,"provider_id": string,"updated_at"?: string | null,"user_id": string
                  }
                  Update: {
                    "created_at"?: string | null,"email"?: never,"id"?: string,"identity_data"?: NonNullable<Json>,"last_sign_in_at"?: string | null,"provider"?: string,"provider_id"?: string,"updated_at"?: string | null,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "identities_user_id_fkey"
      columns: ["user_id"]
isOneToOne: false
      referencedRelation: "users"
      referencedColumns: ["id"]
    }
                  ]
                },"instances": {
                  Row: {
                    "created_at": string | null,"id": string,"raw_base_config": string | null,"updated_at": string | null,"uuid": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string | null,"id": string,"raw_base_config"?: string | null,"updated_at"?: string | null,"uuid"?: string | null
                  }
                  Update: {
                    "created_at"?: string | null,"id"?: string,"raw_base_config"?: string | null,"updated_at"?: string | null,"uuid"?: string | null
                  }
                  Relationships: [
                    
                  ]
                },"mfa_amr_claims": {
                  Row: {
                    "authentication_method": string,"created_at": string,"id": string,"session_id": string,"updated_at": string
                  }
                  ComputedFields: never
                  Insert: {
                    "authentication_method": string,"created_at": string,"id": string,"session_id": string,"updated_at": string
                  }
                  Update: {
                    "authentication_method"?: string,"created_at"?: string,"id"?: string,"session_id"?: string,"updated_at"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "mfa_amr_claims_session_id_fkey"
      columns: ["session_id"]
isOneToOne: false
      referencedRelation: "sessions"
      referencedColumns: ["id"]
    }
                  ]
                },"mfa_challenges": {
                  Row: {
                    "created_at": string,"factor_id": string,"id": string,"ip_address": unknown,"otp_code": string | null,"verified_at": string | null,"web_authn_session_data": Json | null
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at": string,"factor_id": string,"id": string,"ip_address": unknown,"otp_code"?: string | null,"verified_at"?: string | null,"web_authn_session_data"?: Json | null
                  }
                  Update: {
                    "created_at"?: string,"factor_id"?: string,"id"?: string,"ip_address"?: unknown,"otp_code"?: string | null,"verified_at"?: string | null,"web_authn_session_data"?: Json | null
                  }
                  Relationships: [
                    {
      foreignKeyName: "mfa_challenges_auth_factor_id_fkey"
      columns: ["factor_id"]
isOneToOne: false
      referencedRelation: "mfa_factors"
      referencedColumns: ["id"]
    }
                  ]
                },"mfa_factors": {
                  Row: {
                    "created_at": string,"factor_type": Database["auth"]['Enums']["factor_type"],"friendly_name": string | null,"id": string,"last_challenged_at": string | null,"last_webauthn_challenge_data": Json | null,"phone": string | null,"secret": string | null,"status": Database["auth"]['Enums']["factor_status"],"updated_at": string,"user_id": string,"web_authn_aaguid": string | null,"web_authn_credential": Json | null
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at": string,"factor_type": Database["auth"]['Enums']["factor_type"],"friendly_name"?: string | null,"id": string,"last_challenged_at"?: string | null,"last_webauthn_challenge_data"?: Json | null,"phone"?: string | null,"secret"?: string | null,"status": Database["auth"]['Enums']["factor_status"],"updated_at": string,"user_id": string,"web_authn_aaguid"?: string | null,"web_authn_credential"?: Json | null
                  }
                  Update: {
                    "created_at"?: string,"factor_type"?: Database["auth"]['Enums']["factor_type"],"friendly_name"?: string | null,"id"?: string,"last_challenged_at"?: string | null,"last_webauthn_challenge_data"?: Json | null,"phone"?: string | null,"secret"?: string | null,"status"?: Database["auth"]['Enums']["factor_status"],"updated_at"?: string,"user_id"?: string,"web_authn_aaguid"?: string | null,"web_authn_credential"?: Json | null
                  }
                  Relationships: [
                    {
      foreignKeyName: "mfa_factors_user_id_fkey"
      columns: ["user_id"]
isOneToOne: false
      referencedRelation: "users"
      referencedColumns: ["id"]
    }
                  ]
                },"oauth_authorizations": {
                  Row: {
                    "approved_at": string | null,"authorization_code": string | null,"authorization_id": string,"client_id": string,"code_challenge": string | null,"code_challenge_method": Database["auth"]['Enums']["code_challenge_method"] | null,"created_at": string,"expires_at": string,"id": string,"nonce": string | null,"redirect_uri": string,"resource": string | null,"response_type": Database["auth"]['Enums']["oauth_response_type"],"scope": string,"state": string | null,"status": Database["auth"]['Enums']["oauth_authorization_status"],"user_id": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "approved_at"?: string | null,"authorization_code"?: string | null,"authorization_id": string,"client_id": string,"code_challenge"?: string | null,"code_challenge_method"?: Database["auth"]['Enums']["code_challenge_method"] | null,"created_at"?: string,"expires_at"?: string,"id": string,"nonce"?: string | null,"redirect_uri": string,"resource"?: string | null,"response_type"?: Database["auth"]['Enums']["oauth_response_type"],"scope": string,"state"?: string | null,"status"?: Database["auth"]['Enums']["oauth_authorization_status"],"user_id"?: string | null
                  }
                  Update: {
                    "approved_at"?: string | null,"authorization_code"?: string | null,"authorization_id"?: string,"client_id"?: string,"code_challenge"?: string | null,"code_challenge_method"?: Database["auth"]['Enums']["code_challenge_method"] | null,"created_at"?: string,"expires_at"?: string,"id"?: string,"nonce"?: string | null,"redirect_uri"?: string,"resource"?: string | null,"response_type"?: Database["auth"]['Enums']["oauth_response_type"],"scope"?: string,"state"?: string | null,"status"?: Database["auth"]['Enums']["oauth_authorization_status"],"user_id"?: string | null
                  }
                  Relationships: [
                    {
      foreignKeyName: "oauth_authorizations_client_id_fkey"
      columns: ["client_id"]
isOneToOne: false
      referencedRelation: "oauth_clients"
      referencedColumns: ["id"]
    },{
      foreignKeyName: "oauth_authorizations_user_id_fkey"
      columns: ["user_id"]
isOneToOne: false
      referencedRelation: "users"
      referencedColumns: ["id"]
    }
                  ]
                },"oauth_client_states": {
                  Row: {
                    "code_verifier": string | null,"created_at": string,"id": string,"provider_type": string
                  }
                  ComputedFields: never
                  Insert: {
                    "code_verifier"?: string | null,"created_at": string,"id": string,"provider_type": string
                  }
                  Update: {
                    "code_verifier"?: string | null,"created_at"?: string,"id"?: string,"provider_type"?: string
                  }
                  Relationships: [
                    
                  ]
                },"oauth_clients": {
                  Row: {
                    "client_name": string | null,"client_secret_hash": string | null,"client_type": Database["auth"]['Enums']["oauth_client_type"],"client_uri": string | null,"created_at": string,"deleted_at": string | null,"grant_types": string,"id": string,"logo_uri": string | null,"redirect_uris": string,"registration_type": Database["auth"]['Enums']["oauth_registration_type"],"token_endpoint_auth_method": string,"updated_at": string
                  }
                  ComputedFields: never
                  Insert: {
                    "client_name"?: string | null,"client_secret_hash"?: string | null,"client_type"?: Database["auth"]['Enums']["oauth_client_type"],"client_uri"?: string | null,"created_at"?: string,"deleted_at"?: string | null,"grant_types": string,"id": string,"logo_uri"?: string | null,"redirect_uris": string,"registration_type": Database["auth"]['Enums']["oauth_registration_type"],"token_endpoint_auth_method": string,"updated_at"?: string
                  }
                  Update: {
                    "client_name"?: string | null,"client_secret_hash"?: string | null,"client_type"?: Database["auth"]['Enums']["oauth_client_type"],"client_uri"?: string | null,"created_at"?: string,"deleted_at"?: string | null,"grant_types"?: string,"id"?: string,"logo_uri"?: string | null,"redirect_uris"?: string,"registration_type"?: Database["auth"]['Enums']["oauth_registration_type"],"token_endpoint_auth_method"?: string,"updated_at"?: string
                  }
                  Relationships: [
                    
                  ]
                },"oauth_consents": {
                  Row: {
                    "client_id": string,"granted_at": string,"id": string,"revoked_at": string | null,"scopes": string,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "client_id": string,"granted_at"?: string,"id": string,"revoked_at"?: string | null,"scopes": string,"user_id": string
                  }
                  Update: {
                    "client_id"?: string,"granted_at"?: string,"id"?: string,"revoked_at"?: string | null,"scopes"?: string,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "oauth_consents_client_id_fkey"
      columns: ["client_id"]
isOneToOne: false
      referencedRelation: "oauth_clients"
      referencedColumns: ["id"]
    },{
      foreignKeyName: "oauth_consents_user_id_fkey"
      columns: ["user_id"]
isOneToOne: false
      referencedRelation: "users"
      referencedColumns: ["id"]
    }
                  ]
                },"one_time_tokens": {
                  Row: {
                    "created_at": string,"id": string,"relates_to": string,"token_hash": string,"token_type": Database["auth"]['Enums']["one_time_token_type"],"updated_at": string,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string,"id": string,"relates_to": string,"token_hash": string,"token_type": Database["auth"]['Enums']["one_time_token_type"],"updated_at"?: string,"user_id": string
                  }
                  Update: {
                    "created_at"?: string,"id"?: string,"relates_to"?: string,"token_hash"?: string,"token_type"?: Database["auth"]['Enums']["one_time_token_type"],"updated_at"?: string,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "one_time_tokens_user_id_fkey"
      columns: ["user_id"]
isOneToOne: false
      referencedRelation: "users"
      referencedColumns: ["id"]
    }
                  ]
                },"refresh_tokens": {
                  Row: {
                    "created_at": string | null,"id": number,"instance_id": string | null,"parent": string | null,"revoked": boolean | null,"session_id": string | null,"token": string | null,"updated_at": string | null,"user_id": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string | null,"id"?: number,"instance_id"?: string | null,"parent"?: string | null,"revoked"?: boolean | null,"session_id"?: string | null,"token"?: string | null,"updated_at"?: string | null,"user_id"?: string | null
                  }
                  Update: {
                    "created_at"?: string | null,"id"?: number,"instance_id"?: string | null,"parent"?: string | null,"revoked"?: boolean | null,"session_id"?: string | null,"token"?: string | null,"updated_at"?: string | null,"user_id"?: string | null
                  }
                  Relationships: [
                    {
      foreignKeyName: "refresh_tokens_session_id_fkey"
      columns: ["session_id"]
isOneToOne: false
      referencedRelation: "sessions"
      referencedColumns: ["id"]
    }
                  ]
                },"saml_providers": {
                  Row: {
                    "attribute_mapping": Json | null,"created_at": string | null,"entity_id": string,"id": string,"metadata_url": string | null,"metadata_xml": string,"name_id_format": string | null,"sso_provider_id": string,"updated_at": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "attribute_mapping"?: Json | null,"created_at"?: string | null,"entity_id": string,"id": string,"metadata_url"?: string | null,"metadata_xml": string,"name_id_format"?: string | null,"sso_provider_id": string,"updated_at"?: string | null
                  }
                  Update: {
                    "attribute_mapping"?: Json | null,"created_at"?: string | null,"entity_id"?: string,"id"?: string,"metadata_url"?: string | null,"metadata_xml"?: string,"name_id_format"?: string | null,"sso_provider_id"?: string,"updated_at"?: string | null
                  }
                  Relationships: [
                    {
      foreignKeyName: "saml_providers_sso_provider_id_fkey"
      columns: ["sso_provider_id"]
isOneToOne: false
      referencedRelation: "sso_providers"
      referencedColumns: ["id"]
    }
                  ]
                },"saml_relay_states": {
                  Row: {
                    "created_at": string | null,"flow_state_id": string | null,"for_email": string | null,"id": string,"redirect_to": string | null,"request_id": string,"sso_provider_id": string,"updated_at": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string | null,"flow_state_id"?: string | null,"for_email"?: string | null,"id": string,"redirect_to"?: string | null,"request_id": string,"sso_provider_id": string,"updated_at"?: string | null
                  }
                  Update: {
                    "created_at"?: string | null,"flow_state_id"?: string | null,"for_email"?: string | null,"id"?: string,"redirect_to"?: string | null,"request_id"?: string,"sso_provider_id"?: string,"updated_at"?: string | null
                  }
                  Relationships: [
                    {
      foreignKeyName: "saml_relay_states_flow_state_id_fkey"
      columns: ["flow_state_id"]
isOneToOne: false
      referencedRelation: "flow_state"
      referencedColumns: ["id"]
    },{
      foreignKeyName: "saml_relay_states_sso_provider_id_fkey"
      columns: ["sso_provider_id"]
isOneToOne: false
      referencedRelation: "sso_providers"
      referencedColumns: ["id"]
    }
                  ]
                },"schema_migrations": {
                  Row: {
                    "version": string
                  }
                  ComputedFields: never
                  Insert: {
                    "version": string
                  }
                  Update: {
                    "version"?: string
                  }
                  Relationships: [
                    
                  ]
                },"sessions": {
                  Row: {
                    "aal": Database["auth"]['Enums']["aal_level"] | null,"created_at": string | null,"factor_id": string | null,"id": string,"ip": unknown,"not_after": string | null,"oauth_client_id": string | null,"refresh_token_counter": number | null,"refresh_token_hmac_key": string | null,"refreshed_at": string | null,"scopes": string | null,"tag": string | null,"updated_at": string | null,"user_agent": string | null,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "aal"?: Database["auth"]['Enums']["aal_level"] | null,"created_at"?: string | null,"factor_id"?: string | null,"id": string,"ip"?: unknown,"not_after"?: string | null,"oauth_client_id"?: string | null,"refresh_token_counter"?: number | null,"refresh_token_hmac_key"?: string | null,"refreshed_at"?: string | null,"scopes"?: string | null,"tag"?: string | null,"updated_at"?: string | null,"user_agent"?: string | null,"user_id": string
                  }
                  Update: {
                    "aal"?: Database["auth"]['Enums']["aal_level"] | null,"created_at"?: string | null,"factor_id"?: string | null,"id"?: string,"ip"?: unknown,"not_after"?: string | null,"oauth_client_id"?: string | null,"refresh_token_counter"?: number | null,"refresh_token_hmac_key"?: string | null,"refreshed_at"?: string | null,"scopes"?: string | null,"tag"?: string | null,"updated_at"?: string | null,"user_agent"?: string | null,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "sessions_oauth_client_id_fkey"
      columns: ["oauth_client_id"]
isOneToOne: false
      referencedRelation: "oauth_clients"
      referencedColumns: ["id"]
    },{
      foreignKeyName: "sessions_user_id_fkey"
      columns: ["user_id"]
isOneToOne: false
      referencedRelation: "users"
      referencedColumns: ["id"]
    }
                  ]
                },"sso_domains": {
                  Row: {
                    "created_at": string | null,"domain": string,"id": string,"sso_provider_id": string,"updated_at": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string | null,"domain": string,"id": string,"sso_provider_id": string,"updated_at"?: string | null
                  }
                  Update: {
                    "created_at"?: string | null,"domain"?: string,"id"?: string,"sso_provider_id"?: string,"updated_at"?: string | null
                  }
                  Relationships: [
                    {
      foreignKeyName: "sso_domains_sso_provider_id_fkey"
      columns: ["sso_provider_id"]
isOneToOne: false
      referencedRelation: "sso_providers"
      referencedColumns: ["id"]
    }
                  ]
                },"sso_providers": {
                  Row: {
                    "created_at": string | null,"disabled": boolean | null,"id": string,"resource_id": string | null,"updated_at": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string | null,"disabled"?: boolean | null,"id": string,"resource_id"?: string | null,"updated_at"?: string | null
                  }
                  Update: {
                    "created_at"?: string | null,"disabled"?: boolean | null,"id"?: string,"resource_id"?: string | null,"updated_at"?: string | null
                  }
                  Relationships: [
                    
                  ]
                },"users": {
                  Row: {
                    "aud": string | null,"banned_until": string | null,"confirmation_sent_at": string | null,"confirmation_token": string | null,"confirmed_at": string | null,"created_at": string | null,"deleted_at": string | null,"email": string | null,"email_change": string | null,"email_change_confirm_status": number | null,"email_change_sent_at": string | null,"email_change_token_current": string | null,"email_change_token_new": string | null,"email_confirmed_at": string | null,"encrypted_password": string | null,"id": string,"instance_id": string | null,"invited_at": string | null,"is_anonymous": boolean,"is_sso_user": boolean,"is_super_admin": boolean | null,"last_sign_in_at": string | null,"phone": string | null,"phone_change": string | null,"phone_change_sent_at": string | null,"phone_change_token": string | null,"phone_confirmed_at": string | null,"raw_app_meta_data": Json | null,"raw_user_meta_data": Json | null,"reauthentication_sent_at": string | null,"reauthentication_token": string | null,"recovery_sent_at": string | null,"recovery_token": string | null,"role": string | null,"updated_at": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "aud"?: string | null,"banned_until"?: string | null,"confirmation_sent_at"?: string | null,"confirmation_token"?: string | null,"confirmed_at"?: never,"created_at"?: string | null,"deleted_at"?: string | null,"email"?: string | null,"email_change"?: string | null,"email_change_confirm_status"?: number | null,"email_change_sent_at"?: string | null,"email_change_token_current"?: string | null,"email_change_token_new"?: string | null,"email_confirmed_at"?: string | null,"encrypted_password"?: string | null,"id": string,"instance_id"?: string | null,"invited_at"?: string | null,"is_anonymous"?: boolean,"is_sso_user"?: boolean,"is_super_admin"?: boolean | null,"last_sign_in_at"?: string | null,"phone"?: string | null,"phone_change"?: string | null,"phone_change_sent_at"?: string | null,"phone_change_token"?: string | null,"phone_confirmed_at"?: string | null,"raw_app_meta_data"?: Json | null,"raw_user_meta_data"?: Json | null,"reauthentication_sent_at"?: string | null,"reauthentication_token"?: string | null,"recovery_sent_at"?: string | null,"recovery_token"?: string | null,"role"?: string | null,"updated_at"?: string | null
                  }
                  Update: {
                    "aud"?: string | null,"banned_until"?: string | null,"confirmation_sent_at"?: string | null,"confirmation_token"?: string | null,"confirmed_at"?: never,"created_at"?: string | null,"deleted_at"?: string | null,"email"?: string | null,"email_change"?: string | null,"email_change_confirm_status"?: number | null,"email_change_sent_at"?: string | null,"email_change_token_current"?: string | null,"email_change_token_new"?: string | null,"email_confirmed_at"?: string | null,"encrypted_password"?: string | null,"id"?: string,"instance_id"?: string | null,"invited_at"?: string | null,"is_anonymous"?: boolean,"is_sso_user"?: boolean,"is_super_admin"?: boolean | null,"last_sign_in_at"?: string | null,"phone"?: string | null,"phone_change"?: string | null,"phone_change_sent_at"?: string | null,"phone_change_token"?: string | null,"phone_confirmed_at"?: string | null,"raw_app_meta_data"?: Json | null,"raw_user_meta_data"?: Json | null,"reauthentication_sent_at"?: string | null,"reauthentication_token"?: string | null,"recovery_sent_at"?: string | null,"recovery_token"?: string | null,"role"?: string | null,"updated_at"?: string | null
                  }
                  Relationships: [
                    
                  ]
                },"webauthn_challenges": {
                  Row: {
                    "challenge_type": string,"created_at": string,"expires_at": string,"id": string,"session_data": NonNullable<Json>,"user_id": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "challenge_type": string,"created_at"?: string,"expires_at": string,"id"?: string,"session_data": NonNullable<Json>,"user_id"?: string | null
                  }
                  Update: {
                    "challenge_type"?: string,"created_at"?: string,"expires_at"?: string,"id"?: string,"session_data"?: NonNullable<Json>,"user_id"?: string | null
                  }
                  Relationships: [
                    {
      foreignKeyName: "webauthn_challenges_user_id_fkey"
      columns: ["user_id"]
isOneToOne: false
      referencedRelation: "users"
      referencedColumns: ["id"]
    }
                  ]
                },"webauthn_credentials": {
                  Row: {
                    "aaguid": string | null,"attestation_type": string,"backed_up": boolean,"backup_eligible": boolean,"created_at": string,"credential_id": string,"friendly_name": string,"id": string,"last_used_at": string | null,"public_key": string,"sign_count": number,"transports": NonNullable<Json>,"updated_at": string,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "aaguid"?: string | null,"attestation_type"?: string,"backed_up"?: boolean,"backup_eligible"?: boolean,"created_at"?: string,"credential_id": string,"friendly_name"?: string,"id"?: string,"last_used_at"?: string | null,"public_key": string,"sign_count"?: number,"transports"?: NonNullable<Json>,"updated_at"?: string,"user_id": string
                  }
                  Update: {
                    "aaguid"?: string | null,"attestation_type"?: string,"backed_up"?: boolean,"backup_eligible"?: boolean,"created_at"?: string,"credential_id"?: string,"friendly_name"?: string,"id"?: string,"last_used_at"?: string | null,"public_key"?: string,"sign_count"?: number,"transports"?: NonNullable<Json>,"updated_at"?: string,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "webauthn_credentials_user_id_fkey"
      columns: ["user_id"]
isOneToOne: false
      referencedRelation: "users"
      referencedColumns: ["id"]
    }
                  ]
                }
          }
          Views: {
            [_ in never]: never
          }
          Functions: {
            "email":
{ Args: Record<PropertyKey, never>; Returns: string
                           },
"jwt":
{ Args: Record<PropertyKey, never>; Returns: Json
                           },
"role":
{ Args: Record<PropertyKey, never>; Returns: string
                           },
"uid":
{ Args: Record<PropertyKey, never>; Returns: string
                           }
          }
          Enums: {
            "aal_level": "aal1"|"aal2"|"aal3","code_challenge_method": "s256"|"plain","factor_status": "unverified"|"verified","factor_type": "totp"|"webauthn"|"phone","oauth_authorization_status": "pending"|"approved"|"denied"|"expired","oauth_client_type": "public"|"confidential","oauth_registration_type": "dynamic"|"manual","oauth_response_type": "code","one_time_token_type": "confirmation_token"|"reauthentication_token"|"recovery_token"|"email_change_token_new"|"email_change_token_current"|"phone_change_token"
          }
          CompositeTypes: {
            [_ in never]: never
          }
        },"public": {
          Tables: {
            "habit_metrics": {
                  Row: {
                    "config": NonNullable<Json>,"created_at": string,"habit_id": string,"id": string,"is_required": boolean,"name": string,"sort_order": number,"type": Database["public"]['Enums']["metric_type"],"updated_at": string | null,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "config"?: NonNullable<Json>,"created_at"?: string,"habit_id": string,"id"?: string,"is_required"?: boolean,"name": string,"sort_order"?: number,"type": Database["public"]['Enums']["metric_type"],"updated_at"?: string | null,"user_id": string
                  }
                  Update: {
                    "config"?: NonNullable<Json>,"created_at"?: string,"habit_id"?: string,"id"?: string,"is_required"?: boolean,"name"?: string,"sort_order"?: number,"type"?: Database["public"]['Enums']["metric_type"],"updated_at"?: string | null,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "habit_metrics_habit_id_fkey"
      columns: ["habit_id"]
isOneToOne: false
      referencedRelation: "habits"
      referencedColumns: ["id"]
    }
                  ]
                },"habit_stock_metric_defaults": {
                  Row: {
                    "created_at": string,"habit_metric_id": string,"habit_stock_id": string,"id": string,"should_compound": boolean,"updated_at": string | null,"user_id": string,"value": NonNullable<Json>
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string,"habit_metric_id": string,"habit_stock_id": string,"id"?: string,"should_compound"?: boolean,"updated_at"?: string | null,"user_id": string,"value": NonNullable<Json>
                  }
                  Update: {
                    "created_at"?: string,"habit_metric_id"?: string,"habit_stock_id"?: string,"id"?: string,"should_compound"?: boolean,"updated_at"?: string | null,"user_id"?: string,"value"?: NonNullable<Json>
                  }
                  Relationships: [
                    {
      foreignKeyName: "habit_stock_metric_defaults_habit_metric_id_fkey"
      columns: ["habit_metric_id"]
isOneToOne: false
      referencedRelation: "habit_metrics"
      referencedColumns: ["id"]
    },{
      foreignKeyName: "habit_stock_metric_defaults_habit_stock_id_fkey"
      columns: ["habit_stock_id"]
isOneToOne: false
      referencedRelation: "habit_stocks"
      referencedColumns: ["id"]
    }
                  ]
                },"habit_stocks": {
                  Row: {
                    "cost": number | null,"created_at": string,"currency": string,"habit_id": string,"id": string,"is_depleted": boolean,"name": string,"purchased_at": string,"remaining_items": number | null,"total_items": number | null,"updated_at": string | null,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "cost"?: number | null,"created_at"?: string,"currency"?: string,"habit_id": string,"id"?: string,"is_depleted"?: boolean,"name": string,"purchased_at"?: string,"remaining_items"?: number | null,"total_items"?: number | null,"updated_at"?: string | null,"user_id": string
                  }
                  Update: {
                    "cost"?: number | null,"created_at"?: string,"currency"?: string,"habit_id"?: string,"id"?: string,"is_depleted"?: boolean,"name"?: string,"purchased_at"?: string,"remaining_items"?: number | null,"total_items"?: number | null,"updated_at"?: string | null,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "habit_stocks_habit_id_fkey"
      columns: ["habit_id"]
isOneToOne: false
      referencedRelation: "habits"
      referencedColumns: ["id"]
    }
                  ]
                },"habits": {
                  Row: {
                    "created_at": string,"description": string | null,"icon_path": string | null,"id": string,"motivation": string | null,"name": string,"trait_id": string | null,"updated_at": string | null,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string,"description"?: string | null,"icon_path"?: string | null,"id"?: string,"motivation"?: string | null,"name"?: string,"trait_id"?: string | null,"updated_at"?: string | null,"user_id": string
                  }
                  Update: {
                    "created_at"?: string,"description"?: string | null,"icon_path"?: string | null,"id"?: string,"motivation"?: string | null,"name"?: string,"trait_id"?: string | null,"updated_at"?: string | null,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "habits_trait_id_fkey"
      columns: ["trait_id"]
isOneToOne: false
      referencedRelation: "traits"
      referencedColumns: ["id"]
    }
                  ]
                },"notes": {
                  Row: {
                    "content": string,"created_at": string,"id": string,"occurrence_id": string | null,"period_date": string | null,"period_kind": Database["public"]['Enums']["note_period_kind"] | null,"updated_at": string | null,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "content": string,"created_at"?: string,"id"?: string,"occurrence_id"?: string | null,"period_date"?: string | null,"period_kind"?: Database["public"]['Enums']["note_period_kind"] | null,"updated_at"?: string | null,"user_id": string
                  }
                  Update: {
                    "content"?: string,"created_at"?: string,"id"?: string,"occurrence_id"?: string | null,"period_date"?: string | null,"period_kind"?: Database["public"]['Enums']["note_period_kind"] | null,"updated_at"?: string | null,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "notes_occurrence_id_fkey"
      columns: ["occurrence_id"]
isOneToOne: true
      referencedRelation: "occurrences"
      referencedColumns: ["id"]
    }
                  ]
                },"occurrence_metric_values": {
                  Row: {
                    "created_at": string,"habit_metric_id": string,"id": string,"occurrence_id": string,"updated_at": string | null,"user_id": string,"value": NonNullable<Json>
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string,"habit_metric_id": string,"id"?: string,"occurrence_id": string,"updated_at"?: string | null,"user_id": string,"value": NonNullable<Json>
                  }
                  Update: {
                    "created_at"?: string,"habit_metric_id"?: string,"id"?: string,"occurrence_id"?: string,"updated_at"?: string | null,"user_id"?: string,"value"?: NonNullable<Json>
                  }
                  Relationships: [
                    {
      foreignKeyName: "occurrence_metric_values_habit_metric_id_fkey"
      columns: ["habit_metric_id"]
isOneToOne: false
      referencedRelation: "habit_metrics"
      referencedColumns: ["id"]
    },{
      foreignKeyName: "occurrence_metric_values_occurrence_id_fkey"
      columns: ["occurrence_id"]
isOneToOne: false
      referencedRelation: "occurrences"
      referencedColumns: ["id"]
    }
                  ]
                },"occurrence_stock_usages": {
                  Row: {
                    "created_at": string,"habit_stock_id": string,"id": string,"occurrence_id": string,"quantity": number | null,"updated_at": string | null,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string,"habit_stock_id": string,"id"?: string,"occurrence_id": string,"quantity"?: number | null,"updated_at"?: string | null,"user_id": string
                  }
                  Update: {
                    "created_at"?: string,"habit_stock_id"?: string,"id"?: string,"occurrence_id"?: string,"quantity"?: number | null,"updated_at"?: string | null,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "occurrence_stock_usages_habit_stock_id_fkey"
      columns: ["habit_stock_id"]
isOneToOne: false
      referencedRelation: "habit_stocks"
      referencedColumns: ["id"]
    },{
      foreignKeyName: "occurrence_stock_usages_occurrence_id_fkey"
      columns: ["occurrence_id"]
isOneToOne: false
      referencedRelation: "occurrences"
      referencedColumns: ["id"]
    }
                  ]
                },"occurrences": {
                  Row: {
                    "cost": number | null,"created_at": string,"currency": string | null,"habit_id": string,"has_specific_time": boolean,"id": string,"occurred_at": string,"photo_paths": (string)[] | null,"time_zone": string,"updated_at": string | null,"user_id": string
                  }
                  ComputedFields: never
                  Insert: {
                    "cost"?: number | null,"created_at"?: string,"currency"?: string | null,"habit_id": string,"has_specific_time"?: boolean,"id"?: string,"occurred_at"?: string,"photo_paths"?: (string)[] | null,"time_zone"?: string,"updated_at"?: string | null,"user_id": string
                  }
                  Update: {
                    "cost"?: number | null,"created_at"?: string,"currency"?: string | null,"habit_id"?: string,"has_specific_time"?: boolean,"id"?: string,"occurred_at"?: string,"photo_paths"?: (string)[] | null,"time_zone"?: string,"updated_at"?: string | null,"user_id"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "occurrences_habit_id_fkey"
      columns: ["habit_id"]
isOneToOne: false
      referencedRelation: "habits"
      referencedColumns: ["id"]
    }
                  ]
                },"profiles": {
                  Row: {
                    "created_at": string,"default_currency": string,"email": string | null,"first_day_of_week": Database["public"]['Enums']["days_of_week"],"id": string,"name": string | null,"plan": Database["public"]['Enums']["user_plans"],"updated_at": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string,"default_currency"?: string,"email"?: string | null,"first_day_of_week"?: Database["public"]['Enums']["days_of_week"],"id": string,"name"?: string | null,"plan"?: Database["public"]['Enums']["user_plans"],"updated_at"?: string | null
                  }
                  Update: {
                    "created_at"?: string,"default_currency"?: string,"email"?: string | null,"first_day_of_week"?: Database["public"]['Enums']["days_of_week"],"id"?: string,"name"?: string | null,"plan"?: Database["public"]['Enums']["user_plans"],"updated_at"?: string | null
                  }
                  Relationships: [
                    
                  ]
                },"traits": {
                  Row: {
                    "color": string,"created_at": string,"description": string | null,"id": string,"name": string,"updated_at": string | null,"user_id": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "color": string,"created_at"?: string,"description"?: string | null,"id"?: string,"name": string,"updated_at"?: string | null,"user_id"?: string | null
                  }
                  Update: {
                    "color"?: string,"created_at"?: string,"description"?: string | null,"id"?: string,"name"?: string,"updated_at"?: string | null,"user_id"?: string | null
                  }
                  Relationships: [
                    
                  ]
                }
          }
          Views: {
            [_ in never]: never
          }
          Functions: {
            "delete_user":
{ Args: Record<PropertyKey, never>; Returns: undefined
                           },
"get_habits_stats":
{ Args: { "p_habit_ids": (string)[],"p_time_zone"?: string }; Returns: Database["public"]['CompositeTypes']["habit_stats"][]
                          SetofOptions: {
        from: "*"
        to: "habit_stats"
        isOneToOne: false
        isSetofReturn: true
      } },
"get_longest_streak":
{ Args: { "p_habit_id": string,"p_time_zone"?: string }; Returns: Database["public"]['CompositeTypes']["streak_info"]
                          SetofOptions: {
        from: "*"
        to: "streak_info"
        isOneToOne: true
        isSetofReturn: false
      } }
          }
          Enums: {
            "days_of_week": "sun"|"mon","metric_type": "number"|"duration"|"percentage"|"scale"|"range"|"choice"|"boolean"|"text","note_period_kind": "day"|"week"|"month","user_plans": "free"|"pro"
          }
          CompositeTypes: {
            "habit_stats": {
                        "habit_id": string | null,"last_entry_at": string | null,"longest_streak_length": number | null,"longest_streak_start": string | null,"longest_streak_end": string | null,"total_entries": number | null
                      },"streak_info": {
                        "streak_length": number | null,"streak_start": string | null,"streak_end": string | null
                      }
          }
        },"storage": {
          Tables: {
            "buckets": {
                  Row: {
                    "allowed_mime_types": (string)[] | null,"avif_autodetection": boolean | null,"created_at": string | null,"file_size_limit": number | null,"id": string,"name": string,"owner": string | null,"owner_id": string | null,"public": boolean | null,"type": Database["storage"]['Enums']["buckettype"],"updated_at": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "allowed_mime_types"?: (string)[] | null,"avif_autodetection"?: boolean | null,"created_at"?: string | null,"file_size_limit"?: number | null,"id": string,"name": string,"owner"?: string | null,"owner_id"?: string | null,"public"?: boolean | null,"type"?: Database["storage"]['Enums']["buckettype"],"updated_at"?: string | null
                  }
                  Update: {
                    "allowed_mime_types"?: (string)[] | null,"avif_autodetection"?: boolean | null,"created_at"?: string | null,"file_size_limit"?: number | null,"id"?: string,"name"?: string,"owner"?: string | null,"owner_id"?: string | null,"public"?: boolean | null,"type"?: Database["storage"]['Enums']["buckettype"],"updated_at"?: string | null
                  }
                  Relationships: [
                    
                  ]
                },"buckets_analytics": {
                  Row: {
                    "created_at": string,"deleted_at": string | null,"format": string,"id": string,"name": string,"type": Database["storage"]['Enums']["buckettype"],"updated_at": string
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string,"deleted_at"?: string | null,"format"?: string,"id"?: string,"name": string,"type"?: Database["storage"]['Enums']["buckettype"],"updated_at"?: string
                  }
                  Update: {
                    "created_at"?: string,"deleted_at"?: string | null,"format"?: string,"id"?: string,"name"?: string,"type"?: Database["storage"]['Enums']["buckettype"],"updated_at"?: string
                  }
                  Relationships: [
                    
                  ]
                },"buckets_vectors": {
                  Row: {
                    "created_at": string,"id": string,"type": Database["storage"]['Enums']["buckettype"],"updated_at": string
                  }
                  ComputedFields: never
                  Insert: {
                    "created_at"?: string,"id": string,"type"?: Database["storage"]['Enums']["buckettype"],"updated_at"?: string
                  }
                  Update: {
                    "created_at"?: string,"id"?: string,"type"?: Database["storage"]['Enums']["buckettype"],"updated_at"?: string
                  }
                  Relationships: [
                    
                  ]
                },"iceberg_namespaces": {
                  Row: {
                    "bucket_name": string,"catalog_id": string,"created_at": string,"id": string,"metadata": NonNullable<Json>,"name": string,"updated_at": string
                  }
                  ComputedFields: never
                  Insert: {
                    "bucket_name": string,"catalog_id": string,"created_at"?: string,"id"?: string,"metadata"?: NonNullable<Json>,"name": string,"updated_at"?: string
                  }
                  Update: {
                    "bucket_name"?: string,"catalog_id"?: string,"created_at"?: string,"id"?: string,"metadata"?: NonNullable<Json>,"name"?: string,"updated_at"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "iceberg_namespaces_catalog_id_fkey"
      columns: ["catalog_id"]
isOneToOne: false
      referencedRelation: "buckets_analytics"
      referencedColumns: ["id"]
    }
                  ]
                },"iceberg_tables": {
                  Row: {
                    "bucket_name": string,"catalog_id": string,"created_at": string,"id": string,"location": string,"name": string,"namespace_id": string,"remote_table_id": string | null,"shard_id": string | null,"shard_key": string | null,"updated_at": string
                  }
                  ComputedFields: never
                  Insert: {
                    "bucket_name": string,"catalog_id": string,"created_at"?: string,"id"?: string,"location": string,"name": string,"namespace_id": string,"remote_table_id"?: string | null,"shard_id"?: string | null,"shard_key"?: string | null,"updated_at"?: string
                  }
                  Update: {
                    "bucket_name"?: string,"catalog_id"?: string,"created_at"?: string,"id"?: string,"location"?: string,"name"?: string,"namespace_id"?: string,"remote_table_id"?: string | null,"shard_id"?: string | null,"shard_key"?: string | null,"updated_at"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "iceberg_tables_catalog_id_fkey"
      columns: ["catalog_id"]
isOneToOne: false
      referencedRelation: "buckets_analytics"
      referencedColumns: ["id"]
    },{
      foreignKeyName: "iceberg_tables_namespace_id_fkey"
      columns: ["namespace_id"]
isOneToOne: false
      referencedRelation: "iceberg_namespaces"
      referencedColumns: ["id"]
    }
                  ]
                },"migrations": {
                  Row: {
                    "executed_at": string | null,"hash": string,"id": number,"name": string
                  }
                  ComputedFields: never
                  Insert: {
                    "executed_at"?: string | null,"hash": string,"id": number,"name": string
                  }
                  Update: {
                    "executed_at"?: string | null,"hash"?: string,"id"?: number,"name"?: string
                  }
                  Relationships: [
                    
                  ]
                },"objects": {
                  Row: {
                    "bucket_id": string | null,"created_at": string | null,"id": string,"last_accessed_at": string | null,"metadata": Json | null,"name": string | null,"owner": string | null,"owner_id": string | null,"path_tokens": (string)[] | null,"updated_at": string | null,"user_metadata": Json | null,"version": string | null
                  }
                  ComputedFields: never
                  Insert: {
                    "bucket_id"?: string | null,"created_at"?: string | null,"id"?: string,"last_accessed_at"?: string | null,"metadata"?: Json | null,"name"?: string | null,"owner"?: string | null,"owner_id"?: string | null,"path_tokens"?: never,"updated_at"?: string | null,"user_metadata"?: Json | null,"version"?: string | null
                  }
                  Update: {
                    "bucket_id"?: string | null,"created_at"?: string | null,"id"?: string,"last_accessed_at"?: string | null,"metadata"?: Json | null,"name"?: string | null,"owner"?: string | null,"owner_id"?: string | null,"path_tokens"?: never,"updated_at"?: string | null,"user_metadata"?: Json | null,"version"?: string | null
                  }
                  Relationships: [
                    {
      foreignKeyName: "objects_bucketId_fkey"
      columns: ["bucket_id"]
isOneToOne: false
      referencedRelation: "buckets"
      referencedColumns: ["id"]
    }
                  ]
                },"s3_multipart_uploads": {
                  Row: {
                    "bucket_id": string,"created_at": string,"id": string,"in_progress_size": number,"key": string,"metadata": Json | null,"owner_id": string | null,"upload_signature": string,"user_metadata": Json | null,"version": string
                  }
                  ComputedFields: never
                  Insert: {
                    "bucket_id": string,"created_at"?: string,"id": string,"in_progress_size"?: number,"key": string,"metadata"?: Json | null,"owner_id"?: string | null,"upload_signature": string,"user_metadata"?: Json | null,"version": string
                  }
                  Update: {
                    "bucket_id"?: string,"created_at"?: string,"id"?: string,"in_progress_size"?: number,"key"?: string,"metadata"?: Json | null,"owner_id"?: string | null,"upload_signature"?: string,"user_metadata"?: Json | null,"version"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "s3_multipart_uploads_bucket_id_fkey"
      columns: ["bucket_id"]
isOneToOne: false
      referencedRelation: "buckets"
      referencedColumns: ["id"]
    }
                  ]
                },"s3_multipart_uploads_parts": {
                  Row: {
                    "bucket_id": string,"created_at": string,"etag": string,"id": string,"key": string,"owner_id": string | null,"part_number": number,"size": number,"upload_id": string,"version": string
                  }
                  ComputedFields: never
                  Insert: {
                    "bucket_id": string,"created_at"?: string,"etag": string,"id"?: string,"key": string,"owner_id"?: string | null,"part_number": number,"size"?: number,"upload_id": string,"version": string
                  }
                  Update: {
                    "bucket_id"?: string,"created_at"?: string,"etag"?: string,"id"?: string,"key"?: string,"owner_id"?: string | null,"part_number"?: number,"size"?: number,"upload_id"?: string,"version"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "s3_multipart_uploads_parts_bucket_id_fkey"
      columns: ["bucket_id"]
isOneToOne: false
      referencedRelation: "buckets"
      referencedColumns: ["id"]
    },{
      foreignKeyName: "s3_multipart_uploads_parts_upload_id_fkey"
      columns: ["upload_id"]
isOneToOne: false
      referencedRelation: "s3_multipart_uploads"
      referencedColumns: ["id"]
    }
                  ]
                },"vector_indexes": {
                  Row: {
                    "bucket_id": string,"created_at": string,"data_type": string,"dimension": number,"distance_metric": string,"id": string,"metadata_configuration": Json | null,"name": string,"updated_at": string
                  }
                  ComputedFields: never
                  Insert: {
                    "bucket_id": string,"created_at"?: string,"data_type": string,"dimension": number,"distance_metric": string,"id"?: string,"metadata_configuration"?: Json | null,"name": string,"updated_at"?: string
                  }
                  Update: {
                    "bucket_id"?: string,"created_at"?: string,"data_type"?: string,"dimension"?: number,"distance_metric"?: string,"id"?: string,"metadata_configuration"?: Json | null,"name"?: string,"updated_at"?: string
                  }
                  Relationships: [
                    {
      foreignKeyName: "vector_indexes_bucket_id_fkey"
      columns: ["bucket_id"]
isOneToOne: false
      referencedRelation: "buckets_vectors"
      referencedColumns: ["id"]
    }
                  ]
                }
          }
          Views: {
            [_ in never]: never
          }
          Functions: {
            "allow_any_operation":
{ Args: { "expected_operations": (string)[] }; Returns: boolean
                           },
"allow_only_operation":
{ Args: { "expected_operation": string }; Returns: boolean
                           },
"can_insert_object":
{ Args: { "bucketid": string,"metadata": Json,"name": string,"owner": string }; Returns: undefined
                           },
"extension":
{ Args: { "name": string }; Returns: string
                           },
"filename":
{ Args: { "name": string }; Returns: string
                           },
"foldername":
{ Args: { "name": string }; Returns: (string)[]
                           },
"get_common_prefix":
{ Args: { "p_delimiter": string,"p_key": string,"p_prefix": string }; Returns: string
                           },
"get_size_by_bucket":
{ Args: Record<PropertyKey, never>; Returns: {
              "bucket_id": string,"size": number
            }[]
                           },
"list_multipart_uploads_with_delimiter":
{ Args: { "bucket_id": string,"delimiter_param": string,"max_keys"?: number,"next_key_token"?: string,"next_upload_token"?: string,"prefix_param": string }; Returns: {
              "created_at": string,"id": string,"key": string
            }[]
                           },
"list_objects_with_delimiter":
{ Args: { "_bucket_id": string,"delimiter_param": string,"max_keys"?: number,"next_token"?: string,"prefix_param": string,"sort_order"?: string,"start_after"?: string }; Returns: {
              "created_at": string,"id": string,"last_accessed_at": string,"metadata": Json,"name": string,"updated_at": string
            }[]
                           },
"operation":
{ Args: Record<PropertyKey, never>; Returns: string
                           },
"search":
{ Args: { "bucketname": string,"levels"?: number,"limits"?: number,"offsets"?: number,"prefix": string,"search"?: string,"sortcolumn"?: string,"sortorder"?: string }; Returns: {
              "created_at": string,"id": string,"last_accessed_at": string,"metadata": Json,"name": string,"updated_at": string
            }[]
                           },
"search_by_timestamp":
{ Args: { "p_bucket_id": string,"p_level": number,"p_limit": number,"p_prefix": string,"p_sort_column": string,"p_sort_column_after": string,"p_sort_order": string,"p_start_after": string }; Returns: {
              "created_at": string,"id": string,"key": string,"last_accessed_at": string,"metadata": Json,"name": string,"updated_at": string
            }[]
                           },
"search_v2":
{ Args: { "bucket_name": string,"levels"?: number,"limits"?: number,"prefix": string,"sort_column"?: string,"sort_column_after"?: string,"sort_order"?: string,"start_after"?: string }; Returns: {
              "created_at": string,"id": string,"key": string,"last_accessed_at": string,"metadata": Json,"name": string,"updated_at": string
            }[]
                           }
          }
          Enums: {
            "buckettype": "STANDARD"|"ANALYTICS"|"VECTOR"
          }
          CompositeTypes: {
            [_ in never]: never
          }
        }
}

type DatabaseWithoutInternals = Omit<Database, '__InternalSupabase'>

type DefaultSchema = DatabaseWithoutInternals[Extract<keyof Database, "public">]

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])
    : never = never
> = DefaultSchemaTableNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])[TableName] extends {
      Row: infer R
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
  ? (DefaultSchema["Tables"] & DefaultSchema["Views"])[DefaultSchemaTableNameOrOptions] extends {
      Row: infer R
    }
    ? R
    : never
  : never

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never
> = DefaultSchemaTableNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Insert: infer I
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
  ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
      Insert: infer I
    }
    ? I
    : never
  : never

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never
> = DefaultSchemaTableNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Update: infer U
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
  ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
      Update: infer U
    }
    ? U
    : never
  : never

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
    | keyof DefaultSchema["Enums"]
    | { schema: keyof DatabaseWithoutInternals },
  EnumName extends DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"]
    : never = never
> = DefaultSchemaEnumNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema["Enums"]
  ? DefaultSchema["Enums"][DefaultSchemaEnumNameOrOptions]
  : never

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    | keyof DefaultSchema["CompositeTypes"]
    | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"]
    : never = never
> = PublicCompositeTypeNameOrOptions extends { schema: keyof DatabaseWithoutInternals }
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema["CompositeTypes"]
  ? DefaultSchema["CompositeTypes"][PublicCompositeTypeNameOrOptions]
  : never

export const Constants = {
  "auth": {
          Enums: {
            "aal_level": ["aal1", "aal2", "aal3"],"code_challenge_method": ["s256", "plain"],"factor_status": ["unverified", "verified"],"factor_type": ["totp", "webauthn", "phone"],"oauth_authorization_status": ["pending", "approved", "denied", "expired"],"oauth_client_type": ["public", "confidential"],"oauth_registration_type": ["dynamic", "manual"],"oauth_response_type": ["code"],"one_time_token_type": ["confirmation_token", "reauthentication_token", "recovery_token", "email_change_token_new", "email_change_token_current", "phone_change_token"]
          }
        },"public": {
          Enums: {
            "days_of_week": ["sun", "mon"],"metric_type": ["number", "duration", "percentage", "scale", "range", "choice", "boolean", "text"],"note_period_kind": ["day", "week", "month"],"user_plans": ["free", "pro"]
          }
        },"storage": {
          Enums: {
            "buckettype": ["STANDARD", "ANALYTICS", "VECTOR"]
          }
        }
} as const
